import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInterestsHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Additional Interests",
        defaultMessage: "Additional Interests"
    },
    contractofSale: {
        id: 'twia.commercial.translation.additionalInterestAccordion.Contract of Sale',
        defaultMessage: 'Contract of Sale'
    },
    mortgagee: {
        id: 'twia.commercial.translation.additionalInterestAccordion.Mortgagee',
        defaultMessage: 'Mortgagee'
    },
    lossPayee: {
        id: 'twia.commercial.translation.additionalInterestAccordion.Loss Payee',
        defaultMessage: 'Loss Payee'
    },
})